import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Divider from "../../../components/Divider";
import TwoSections from "../../../components/TwoSections";
import TwoSectionsImages from "../../../components/TwoSectionsImages";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const GifPlayer = makeShortcode("GifPlayer");
const Video = makeShortcode("Video");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Connect zones allow clients and IBM employees to engage in a variety of formal or informal interactions. Whether open or closed, these environments provide space to present, share and co-create ideas and business solutions.`}</p>
    </PageDescription>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <GifPlayer className="video-player" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/2bf065fd604eacda74a81cadcb44f45d/connect.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAgP/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB2h20KjRX/8QAGRAAAwEBAQAAAAAAAAAAAAAAAQISABED/9oACAEBAAEFAqVS3oswCIXSpHOb/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGhAAAwADAQAAAAAAAAAAAAAAAAERAhAxcf/aAAgBAQAGPwKPGjmE9EzhzX//xAAZEAEBAQEBAQAAAAAAAAAAAAABEQAhQVH/2gAIAQEAAT8hsg6813QHKMfaAeYpZzIQjo4CG//aAAwDAQACAAMAAAAQPw//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPxCH/8QAGxABAAICAwAAAAAAAAAAAAAAAQARITFBUYH/2gAIAQEAAT8QWqAAVHRAKbZIF8YpqFThaXAAWLl7ijbATDGtSDAOp//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "animation of 3 different connect zones",
              "title": "animation of 3 different connect zones",
              "src": "/workplace-xg/static/14e5484c1fa28a99d149b92ebc988edf/2e753/ten-person-conference-room.jpg",
              "srcSet": ["/workplace-xg/static/14e5484c1fa28a99d149b92ebc988edf/69549/ten-person-conference-room.jpg 288w", "/workplace-xg/static/14e5484c1fa28a99d149b92ebc988edf/473e3/ten-person-conference-room.jpg 576w", "/workplace-xg/static/14e5484c1fa28a99d149b92ebc988edf/2e753/ten-person-conference-room.jpg 1152w", "/workplace-xg/static/14e5484c1fa28a99d149b92ebc988edf/74f4b/ten-person-conference-room.jpg 1728w", "/workplace-xg/static/14e5484c1fa28a99d149b92ebc988edf/f35b7/ten-person-conference-room.jpg 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
    </Row>
    <h2>{`Signature moments`}</h2>
    <p>{`Connect zones are centrally located spaces for clients and IBM employees to meet, share and co-create. They are easily accessible and visible upon arrival onto the floor and are typically adjacent to Welcome and Play zones. These spaces are fully equipped to enable sharing and co-creation activities. A broader spectrum of accent colors in textiles, finishes and graphics can be used to energize these spaces.`}</p>
    <Divider mdxType="Divider" />
    <TwoSections title="Finish palette" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
Connect zones are places to absorb input from and share ideas with clients, and the surroundings shouldn’t overwhelm these important exchanges. Wood continues to play an important role in our finish palette, unifying the interior design across different space types. In Connect zones, wood finishes create proportional and structural relationships among furniture, wall surfaces, flooring and core elements. Additional finishes, such as tile and concrete, provide extra durability for heavy traffic areas. Area rugs, textiles and furniture can provide a pop of color and interest within this neutral shell.
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQDAQX/xAAXAQEBAQEAAAAAAAAAAAAAAAACAQQF/9oADAMBAAIQAxAAAAH3YZ8pbExHsYTkOtl//8QAGxAAAgIDAQAAAAAAAAAAAAAAAAECAxESEzL/2gAIAQEAAQUCJ+zuOzL2RwrLFpM//8QAFxEBAAMAAAAAAAAAAAAAAAAAEAERQv/aAAgBAwEBPwGjMH//xAAYEQACAwAAAAAAAAAAAAAAAAAAEQEQMf/aAAgBAgEBPwFiJ2v/xAAbEAACAgMBAAAAAAAAAAAAAAAAAQIQIjEyM//aAAgBAQAGPwIdeiHkdI4HGOq//8QAHBAAAwABBQAAAAAAAAAAAAAAAAEREDFRkdHx/9oACAEBAAE/IcKiedBUS+D3kPZCESaIQ//aAAwDAQACAAMAAAAQUNh9/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAEREKH/2gAIAQMBAT8QcFQ+Gf/EABoRAAICAwAAAAAAAAAAAAAAAAABEFERMfD/2gAIAQIBAT8QSsyo09Uf/8QAHhABAAIBBAMAAAAAAAAAAAAAAQARUSExQWFxkbH/2gAIAQEAAT8Ql8dJ8JR1UvzH2fZCM3HccJRCugDrwuTuFYNoOCriL2n/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "connect zone finish palette",
            "title": "connect zone finish palette",
            "src": "/workplace-xg/static/1bd631732833529744086a81eb36e30e/2e753/connect-zone-finish-palette.jpg",
            "srcSet": ["/workplace-xg/static/1bd631732833529744086a81eb36e30e/69549/connect-zone-finish-palette.jpg 288w", "/workplace-xg/static/1bd631732833529744086a81eb36e30e/473e3/connect-zone-finish-palette.jpg 576w", "/workplace-xg/static/1bd631732833529744086a81eb36e30e/2e753/connect-zone-finish-palette.jpg 1152w", "/workplace-xg/static/1bd631732833529744086a81eb36e30e/a052a/connect-zone-finish-palette.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Color strategy" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
As a backdrop to the collaboration and co-creation activities with clients that happen in Connect zones, a wider color palette should be used with restraint and for specific emphasis. Although we lead with blue in the Welcome and Arrive zones, a richer spectrum of accent colors across architectural finishes, furniture and textiles in the Connect zones can help fuel active, creative interactions.
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAFzbRLMKgf/xAAaEAACAgMAAAAAAAAAAAAAAAAAAQIRAxAh/9oACAEBAAEFAuopjhkvf//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABcQAAMBAAAAAAAAAAAAAAAAAAEQISD/2gAIAQEABj8Cqgx//8QAGBAAAgMAAAAAAAAAAAAAAAAAAREQIHH/2gAIAQEAAT8hzxOGEU//2gAMAwEAAgADAAAAEBDP/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8Qqv/EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/EIf/xAAaEAEBAAMBAQAAAAAAAAAAAAABABEhMUGh/9oACAEBAAE/EAIArPyV6oPJ7eJdbmGzf//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "color in connect space on slat wall",
              "title": "color in connect space on slat wall",
              "src": "/workplace-xg/static/1a95ed5abc0c06b67f1a4421be9f7362/2e753/color-in-connect-space-on-slat-wall.jpg",
              "srcSet": ["/workplace-xg/static/1a95ed5abc0c06b67f1a4421be9f7362/69549/color-in-connect-space-on-slat-wall.jpg 288w", "/workplace-xg/static/1a95ed5abc0c06b67f1a4421be9f7362/473e3/color-in-connect-space-on-slat-wall.jpg 576w", "/workplace-xg/static/1a95ed5abc0c06b67f1a4421be9f7362/2e753/color-in-connect-space-on-slat-wall.jpg 1152w", "/workplace-xg/static/1a95ed5abc0c06b67f1a4421be9f7362/a052a/color-in-connect-space-on-slat-wall.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwAC/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAR02aOSP/8QAGRAAAwEBAQAAAAAAAAAAAAAAAQIRAwAh/9oACAEBAAEFAkzpzW8whQ+otDKL/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8BZ//EABYRAAMAAAAAAAAAAAAAAAAAAAEQMf/aAAgBAgEBPwEVf//EABkQAAIDAQAAAAAAAAAAAAAAAAAxARARQf/aAAgBAQAGPwLIpGwLoz//xAAbEAEAAgIDAAAAAAAAAAAAAAABACERQTFhsf/aAAgBAQABPyFp2Gq7QqUHqAbF3Ga1Lc5Zj0T/2gAMAwEAAgADAAAAEFMP/8QAGBEBAQADAAAAAAAAAAAAAAAAAQARITH/2gAIAQMBAT8QChie6v/EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAIAQIBAT8QQdGk5f/EABwQAQEAAgMBAQAAAAAAAAAAAAERACExQaFx8P/aAAgBAQABPxA8yDavUc1MJ1CEzbK11HmFaDRBOXeFOxgkz98xnEWynrn/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "color in connect space on glass wall",
              "title": "color in connect space on glass wall",
              "src": "/workplace-xg/static/0a6ea7814050cccfcfc35a7d4ef85cff/473e3/color-in-connect-space-on-glass-wall.jpg",
              "srcSet": ["/workplace-xg/static/0a6ea7814050cccfcfc35a7d4ef85cff/69549/color-in-connect-space-on-glass-wall.jpg 288w", "/workplace-xg/static/0a6ea7814050cccfcfc35a7d4ef85cff/473e3/color-in-connect-space-on-glass-wall.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAe7NiKP/xAAZEAACAwEAAAAAAAAAAAAAAAAAEgECESD/2gAIAQEAAQUCaB6m8f/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABYQAQEBAAAAAAAAAAAAAAAAADEAIP/aAAgBAQAGPwJnP//EABoQAAMAAwEAAAAAAAAAAAAAAAABERAhMWH/2gAIAQEAAT8h2tRUeESPjxCH/9oADAMBAAIAAwAAABAzz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABoQAQADAQEBAAAAAAAAAAAAAAEAEVExQWH/2gAIAQEAAT8QH8sJfJw9fsDsE0ZRkpkphP/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "accent color in chairs",
              "title": "accent color in chairs",
              "src": "/workplace-xg/static/33dfdbaa355ca72857ef04767d543a11/473e3/accent-color-in-chairs.jpg",
              "srcSet": ["/workplace-xg/static/33dfdbaa355ca72857ef04767d543a11/69549/accent-color-in-chairs.jpg 288w", "/workplace-xg/static/33dfdbaa355ca72857ef04767d543a11/473e3/accent-color-in-chairs.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Brand expression" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
Connect zones cover a broad spectrum of space types, from more formal, enclosed spaces, to open co-creation workspaces, where clients and IBM employees can innovate together. Calibrate the brand expression to fit these varied environments. For example, the formal space may use less overt brand elements, such as texture and pattern, but consider more playful, expressive elements to energize the co-creation environment.
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwACBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHuUdDR1f/EABkQAAMAAwAAAAAAAAAAAAAAAAABAgQRI//aAAgBAQABBQJCaIpXJox1y//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAIDAQAAAAAAAAAAAAAAAAAQAREhUf/aAAgBAQAGPwJXC0zp/8QAGRABAQEAAwAAAAAAAAAAAAAAAQARMWGx/9oACAEBAAE/IcbaruAkEFYYDhr2/9oADAMBAAIAAwAAABCoD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/EIj/xAAaEAEBAQEBAQEAAAAAAAAAAAABESEAMUFh/9oACAEBAAE/EGFlzhgYbNOwWg3fEY84v2nG4p+vKzRV8rW9/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "graphic IBM Quantum platform wall art",
              "title": "graphic IBM Quantum platform wall art",
              "src": "/workplace-xg/static/29d154357df6ee4df572cd6b50ba7a57/4edc6/graphic-quantum-brass-wall-art.jpg",
              "srcSet": ["/workplace-xg/static/29d154357df6ee4df572cd6b50ba7a57/69549/graphic-quantum-brass-wall-art.jpg 288w", "/workplace-xg/static/29d154357df6ee4df572cd6b50ba7a57/473e3/graphic-quantum-brass-wall-art.jpg 576w", "/workplace-xg/static/29d154357df6ee4df572cd6b50ba7a57/4edc6/graphic-quantum-brass-wall-art.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAD/9oADAMBAAIQAxAAAAHrhGmmRQAf/8QAFRABAQAAAAAAAAAAAAAAAAAAIBH/2gAIAQEAAQUCEP8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQAGPwIf/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAERURAx/9oACAEBAAE/IRP0wlFBBcw//9oADAMBAAIAAwAAABBo53//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAcEAEAAgIDAQAAAAAAAAAAAAABADERQSFRcYH/2gAIAQEAAT8QHGFgtouTxEHW7LgVOTuGIYrR1LfZ3GvE/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "wall art brand expression in wood",
              "title": "wall art brand expression in wood",
              "src": "/workplace-xg/static/590fa5ca5013ec2a98d347336cb2a13c/473e3/wall-art-brand-expression-in-wood.jpg",
              "srcSet": ["/workplace-xg/static/590fa5ca5013ec2a98d347336cb2a13c/69549/wall-art-brand-expression-in-wood.jpg 288w", "/workplace-xg/static/590fa5ca5013ec2a98d347336cb2a13c/473e3/wall-art-brand-expression-in-wood.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "578px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "99.65277777777779%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIEBQP/xAAVAQEBAAAAAAAAAAAAAAAAAAACAf/aAAwDAQACEAMQAAABqXc7TNzUzM+oFVDH/8QAHRAAAgIBBQAAAAAAAAAAAAAAAQIAAxESISIjM//aAAgBAQABBQIWCKrEv6Cvc6oR2QWvM8//xAAVEQEBAAAAAAAAAAAAAAAAAAAQAf/aAAgBAwEBPwEp/8QAFREBAQAAAAAAAAAAAAAAAAAAEAH/2gAIAQIBAT8BIf/EAB0QAAEEAgMAAAAAAAAAAAAAAAABAhEhEHFBUcH/2gAIAQEABj8CJWh+xPDkfPeLUfs//8QAHRABAAICAgMAAAAAAAAAAAAAAQARITFBkVFh0f/aAAgBAQABPyHBtWHVB4g7sYs6jQUeb1EA2+YKUjmOasPcUpP/2gAMAwEAAgADAAAAEK/Ivf/EABgRAAIDAAAAAAAAAAAAAAAAAAAQESFB/9oACAEDAQE/EMslv//EABgRAAIDAAAAAAAAAAAAAAAAAAAQESFB/9oACAECAQE/ENohv//EABwQAQEAAwEBAQEAAAAAAAAAAAERACExUXFBsf/aAAgBAQABPxCcaQ0HdfMcmOEHXmW6aD+Yq7ChBXn5vDJy9CpZ76mXUlje2MFcACPjHCehSC4xJVLPhn//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "pattern on distraction glass",
              "title": "pattern on distraction glass",
              "src": "/workplace-xg/static/ca58f8538120013017d1dd6402c06259/666d6/pattern-on-distraction-glass.jpg",
              "srcSet": ["/workplace-xg/static/ca58f8538120013017d1dd6402c06259/69549/pattern-on-distraction-glass.jpg 288w", "/workplace-xg/static/ca58f8538120013017d1dd6402c06259/473e3/pattern-on-distraction-glass.jpg 576w", "/workplace-xg/static/ca58f8538120013017d1dd6402c06259/666d6/pattern-on-distraction-glass.jpg 578w"],
              "sizes": "(max-width: 578px) 100vw, 578px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "578px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACZ0lEQVQ4y52SW2/aQBBG+e3tQx8aRYmai3pJH1qJSH2pVLWKKElDqBSlguDgmKQkeG0MtqmUqLWaC2CYr7O7NuESeKilo8FIezyz32QMD1dmGzjxQAymMZqA2QJ6MdRDhIVPxmiSEnIlBuOceLpqISVCmosSnox1KA9XpqS6Q0o6XCyTVXV46muh7OQsACx+lx+R7xV3ssN5z6hDKbRYsv4lorXPEbLFW2zl/+J94QabOxGOHcIpy7uJ0DRN1Ot1uK4L27YhhMDFxcXkyFU+sPrpDz3dvsazD9d4kr3C8sff8iMoJ8I0lFKpDMMwuJZwdHSEWq0Gy7IwHA7HQuERqy0eua3HlYL/HpmTTEJZlDIlQlqQ8igUJGsjU9Z7N04l2cP+QKe8GO6w2oqvrYB45JgYPIbVjnF7S4i7LL4nBnPJ2HdhJPq/YHdDYjDBPdML0bjp4OfhAOf7wPkB4byAuWREz49cCiFinxjMMPBh3wWwCjHMHQ4sRwuQwq4fOcMOHw5YGMDua0SKEoaoFWN1oLbLm5Bn8VcW5En9foBDsbuyww4aPZ/svo8WAngUwBloYaOfCA/4LnOJiKl/4xH3+AP5h/+kVAk9dPCqKGjzQCBbdvD6u8B2xVX1koWChRYLz/jA0nMbG6se3mz4WOe6xVW+m6lQ3qEYhHj3w6EXezZeFgXW9wXeHjrYPnZnOlxZdrC20lR1eUkoscTMjXXYJH2HclSfR5ZjN5Oxp4Vnu5pLTnR67FGHMhS+P3WHfJdaopgNRQYhD8uO0rtLZbKOUk6Fk8wXPobuMF2bvq/WZpzHhNbMqkzyD1eRvhVv6ZyAAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "rebus examples",
              "title": "rebus examples",
              "src": "/workplace-xg/static/574a75abdda8208638d9776add4417a9/778f8/rebus-examples.png",
              "srcSet": ["/workplace-xg/static/574a75abdda8208638d9776add4417a9/7fc1e/rebus-examples.png 288w", "/workplace-xg/static/574a75abdda8208638d9776add4417a9/a5df1/rebus-examples.png 576w", "/workplace-xg/static/574a75abdda8208638d9776add4417a9/778f8/rebus-examples.png 578w"],
              "sizes": "(max-width: 578px) 100vw, 578px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAMEBQL/xAAVAQEBAAAAAAAAAAAAAAAAAAADAv/aAAwDAQACEAMQAAABkWIkHMSGnZrgX0JT/8QAGxAAAgMAAwAAAAAAAAAAAAAAAAIBERIDITH/2gAIAQEAAQUCXxliRuNbxQw09sZhjCn/xAAZEQEAAgMAAAAAAAAAAAAAAAAAAQIREjH/2gAIAQMBAT8Bu2lPWH//xAAZEQEAAgMAAAAAAAAAAAAAAAAAAQIREjH/2gAIAQIBAT8Bq0qjjL//xAAZEAEAAgMAAAAAAAAAAAAAAAAAASEgMTL/2gAIAQEABj8CW1jbmH//xAAaEAEAAgMBAAAAAAAAAAAAAAABACEQQXHR/9oACAEBAAE/IRTkIoOBBO5XFcNxA/Cf/9oADAMBAAIAAwAAABDYJ/8A/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERIWH/2gAIAQMBAT8QaPDqInsg/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERUSH/2gAIAQIBAT8QWiwGnBWn/8QAIBABAAIBAgcAAAAAAAAAAAAAAQARIUFxUWGBkcHR8P/aAAgBAQABPxAui8TvpCGWEAGgrL9wiBUC+Y1u/uIKlyGoNQm9p//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "gradient lenticular brand expresion",
              "title": "gradient lenticular brand expresion",
              "src": "/workplace-xg/static/7be87952795f987ebf0941d71a930ab9/473e3/gradient-lenticular-brand-expresion.jpg",
              "srcSet": ["/workplace-xg/static/7be87952795f987ebf0941d71a930ab9/69549/gradient-lenticular-brand-expresion.jpg 288w", "/workplace-xg/static/7be87952795f987ebf0941d71a930ab9/473e3/gradient-lenticular-brand-expresion.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Furniture" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`Conference rooms and multipurpose rooms should have comfortable seating on casters for extended work sessions, and to allow for rooms to be reconfigured more easily. When used, high-top cafe chairs should have cushions and back supports. A co-creation Connect zone can be implemented in a variety of ways, depending on the site program and business needs. These spaces are intended to be a workspace for clients and IBM teams to innovate and share ideas. The furniture in these spaces, including work surfaces and seating, should be easily reconfigurable to accommodate visioning and knowledge sharing sessions with our clients, agency partners and guests.`}</p>
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAbTglL0BYo//xAAZEAADAQEBAAAAAAAAAAAAAAAAAQISAxP/2gAIAQEAAQUCxkTrL6otuu13SPSkf//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAwEBPwG1j//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPwGNf//EAB0QAAICAQUAAAAAAAAAAAAAAAABAhEQEiExQXH/2gAIAQEABj8C1KVFyV+YafS2FUmcn//EABwQAAICAwEBAAAAAAAAAAAAAAABEUEhUWExgf/aAAgBAQABPyG0cOxFmtOCV4viHiylQ0R5DBhRRUf/2gAMAwEAAgADAAAAEO8f/8QAFhEAAwAAAAAAAAAAAAAAAAAAEBEh/9oACAEDAQE/EGUf/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEB/9oACAECAQE/EMRb/8QAHBABAAMBAAMBAAAAAAAAAAAAAQARITFBYXGh/9oACAEBAAE/EC1FmUHx+wIU01Y07mwzAKrGz19jgTSct2U5NsGUB1RsKqHlJ//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "connect space furniture",
              "title": "connect space furniture",
              "src": "/workplace-xg/static/e12759214eea506f04820e4199836900/4edc6/connect-space-furniture.jpg",
              "srcSet": ["/workplace-xg/static/e12759214eea506f04820e4199836900/69549/connect-space-furniture.jpg 288w", "/workplace-xg/static/e12759214eea506f04820e4199836900/473e3/connect-space-furniture.jpg 576w", "/workplace-xg/static/e12759214eea506f04820e4199836900/4edc6/connect-space-furniture.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMBBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHvxsjRX//EABcQAAMBAAAAAAAAAAAAAAAAAAABAiD/2gAIAQEAAQUCIpt4/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFxABAAMAAAAAAAAAAAAAAAAAAQARIP/aAAgBAQAGPwKNmf/EABgQAAIDAAAAAAAAAAAAAAAAAAAhASBB/9oACAEBAAE/IRGUYq//2gAMAwEAAgADAAAAEOgP/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8Qp//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/EIf/xAAaEAEBAAIDAAAAAAAAAAAAAAABEQAQITGR/9oACAEBAAE/EFhcPFLmkX3T05Gmv//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "connect space stool example",
              "title": "connect space stool example",
              "src": "/workplace-xg/static/7f838bea749a2d1ac214b2f8640ee048/473e3/connect-space-stool-example.jpg",
              "srcSet": ["/workplace-xg/static/7f838bea749a2d1ac214b2f8640ee048/69549/connect-space-stool-example.jpg 288w", "/workplace-xg/static/7f838bea749a2d1ac214b2f8640ee048/473e3/connect-space-stool-example.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIEBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAd+K1RgD/8QAGBAAAwEBAAAAAAAAAAAAAAAAAQIDEAD/2gAIAQEAAQUC6DVY4Bn/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAAABwAAAAAAAAAAAAAAAAAAAQIREyBR/9oACAEBAAY/AgqQmyv/xAAZEAABBQAAAAAAAAAAAAAAAAAQABEhYZH/2gAIAQEAAT8hUY6hYwf/2gAMAwEAAgADAAAAEOPP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGhABAAIDAQAAAAAAAAAAAAAAAREhABAxcf/aAAgBAQABPxDDZQRcCparw08YxmXPGv/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "connect space stool example",
              "title": "connect space stool example",
              "src": "/workplace-xg/static/2d72c4183707d77ba1efc4d98324121c/473e3/connect-space-stool-example-1.jpg",
              "srcSet": ["/workplace-xg/static/2d72c4183707d77ba1efc4d98324121c/69549/connect-space-stool-example-1.jpg 288w", "/workplace-xg/static/2d72c4183707d77ba1efc4d98324121c/473e3/connect-space-stool-example-1.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEEAgP/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABo3Io7DD/xAAaEAABBQEAAAAAAAAAAAAAAAACAAEDESES/9oACAEBAAEFAhPcXKKeGo7d6Il//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGhAAAgMBAQAAAAAAAAAAAAAAAREAAiIQQf/aAAgBAQAGPwJEdzXUZL9jFlP/xAAdEAEAAwABBQAAAAAAAAAAAAABABEhUTFBYXGB/9oACAEBAAE/IQVoDZbc7kfV+xV1VzkofBKh0icT/9oADAMBAAIAAwAAABAIH//EABURAQEAAAAAAAAAAAAAAAAAABAh/9oACAEDAQE/EKf/xAAVEQEBAAAAAAAAAAAAAAAAAAAQIf/aAAgBAgEBPxCH/8QAGxABAQADAQEBAAAAAAAAAAAAAREAITFRccH/2gAIAQEAAT8QS0O9ydxAH2ZymEPpvgxYgJA7dqjiXCRpAfMPU3lb/M//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "connect workshop space",
              "title": "connect workshop space",
              "src": "/workplace-xg/static/5301bb9ad2d2da86d8d3d469d9bf2686/4edc6/connect-workshop-space.jpg",
              "srcSet": ["/workplace-xg/static/5301bb9ad2d2da86d8d3d469d9bf2686/69549/connect-workshop-space.jpg 288w", "/workplace-xg/static/5301bb9ad2d2da86d8d3d469d9bf2686/473e3/connect-workshop-space.jpg 576w", "/workplace-xg/static/5301bb9ad2d2da86d8d3d469d9bf2686/4edc6/connect-workshop-space.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Flooring and ceiling" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
        <p>Meeting rooms may use a variety of ceiling solutions, including slat pattern systems, acoustic tile or gypsum. Lighting should integrate into the ceiling system and allow for rooms to be reconfigured. Co-creation spaces may also use an open or exposed ceiling that’s painted with a neutral finish.</p>
        <p>
  In enclosed meeting rooms, neutral-colored carpet tiles are often used to
  soften the space. The high-traffic and more energetic co-creation spaces can
  use lightly sanded or polished concrete and, when appropriate, luxury vinyl
  tile solutions in neutral finishes.
        </p>
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEBf/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAAB6E8dSIHP/8QAGxAAAwACAwAAAAAAAAAAAAAAAAECAwQSEyH/2gAIAQEAAQUCn0rIjkmXTjItiHPcmf/EABURAQEAAAAAAAAAAAAAAAAAAAAh/9oACAEDAQE/AVf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAADAQADAAAAAAAAAAAAAAAAARECECKB/9oACAEBAAY/ArxSoT3n1HVRH//EABoQAAIDAQEAAAAAAAAAAAAAAAABESExUZH/2gAIAQEAAT8hVypQmRaPw19WPgiHDpIN/EUH/9oADAMBAAIAAwAAABAY7//EABYRAQEBAAAAAAAAAAAAAAAAAAABYf/aAAgBAwEBPxBbl//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxBkf//EAB4QAQACAwACAwAAAAAAAAAAAAEAESExQVFhgaHB/9oACAEBAAE/ELGMmlrECKMPRgIKm+uNeYmUNMHX1uWXW6C+zZ8QtKvqg/s//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "floor and ceiling options for presentation space",
              "title": "floor and ceiling options for presentation space",
              "src": "/workplace-xg/static/093381c9ff2c90d690b64e62a7922289/2e753/floor-and-ceiling-options-for-presentation-space.jpg",
              "srcSet": ["/workplace-xg/static/093381c9ff2c90d690b64e62a7922289/69549/floor-and-ceiling-options-for-presentation-space.jpg 288w", "/workplace-xg/static/093381c9ff2c90d690b64e62a7922289/473e3/floor-and-ceiling-options-for-presentation-space.jpg 576w", "/workplace-xg/static/093381c9ff2c90d690b64e62a7922289/2e753/floor-and-ceiling-options-for-presentation-space.jpg 1152w", "/workplace-xg/static/093381c9ff2c90d690b64e62a7922289/a052a/floor-and-ceiling-options-for-presentation-space.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMBAgT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABrlPOmOC92CQP/8QAGxAAAwADAQEAAAAAAAAAAAAAAQIDABESEyP/2gAIAQEAAQUCKNgSm5rTzL6Js3Ur8zUA4oG4D4//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAACAgEFAAAAAAAAAAAAAAAAAQIhEBESMnGh/9oACAEBAAY/Aqs4+i0jXZQ6QltzE//EABsQAAIDAQEBAAAAAAAAAAAAAAABESFhMVHw/9oACAEBAAE/IU2ksthElSsld36iOpy/Gai3g+AODoIlIoS2X8z/2gAMAwEAAgADAAAAECTIAP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB4QAQEAAgICAwAAAAAAAAAAAAERACExQVFhccHR/9oACAEBAAE/EKdrkX0YgUXo/hjmkmQdvUy+EfJxDxgGZIJdI0/OL8tRFNVwwRY62mCUOxwu8RTUeH2z/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "floor and ceiling options for connect space",
              "title": "floor and ceiling options for connect space",
              "src": "/workplace-xg/static/a4ec824c053692e2edb14e1aadce0e55/473e3/floor-and-ceiling-options-for-connect-space.jpg",
              "srcSet": ["/workplace-xg/static/a4ec824c053692e2edb14e1aadce0e55/69549/floor-and-ceiling-options-for-connect-space.jpg 288w", "/workplace-xg/static/a4ec824c053692e2edb14e1aadce0e55/473e3/floor-and-ceiling-options-for-connect-space.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQFAgP/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABzKbqknSl9OCM8V//xAAdEAEAAQQDAQAAAAAAAAAAAAABAgAEERMDEBIi/9oACAEBAAEFAmMirckPzW6KbMDzOSJ6uF6//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHBABAAEEAwAAAAAAAAAAAAAAAQACEBExISKB/9oACAEBAAY/Au1M4FpZuZz5iCzRYLf/xAAbEAADAQEAAwAAAAAAAAAAAAAAARExIUFRkf/aAAgBAQABPyFu034eyscwjdVHIOnl6J4vyVJIfpqiUc0bP//aAAwDAQACAAMAAAAQbA/8/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHBABAQEBAAIDAAAAAAAAAAAAAREhADFBYYHx/9oACAEBAAE/EFZYaqw8XOGUKX5A2fPSgA7TlaLURFmv7yIbAcMPvhg+s9ZzCgOXecZGUHvlvnv/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "floor and ceiling in connect space",
              "title": "floor and ceiling in connect space",
              "src": "/workplace-xg/static/caff0adc9698271f2979aed176c24341/473e3/floor-and-ceiling-in-connect-space.jpg",
              "srcSet": ["/workplace-xg/static/caff0adc9698271f2979aed176c24341/69549/floor-and-ceiling-in-connect-space.jpg 288w", "/workplace-xg/static/caff0adc9698271f2979aed176c24341/473e3/floor-and-ceiling-in-connect-space.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      